import type { ColumnDef } from "@tanstack/react-table";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import type { StAdjustmentTechnicianGroup } from "@/payroll/pay-breakdown/st-adjustments/types";

// Who this row's pay belongs to. The name leads and the ServiceTitan id sits
// under it: the name is what tells you whose money you are moving, while the id
// is what you need when reconciling against ServiceTitan itself.
export const TECHNICIAN_COLUMN: ColumnDef<
  StAdjustmentTechnicianGroup,
  unknown
> = {
  id: "technician",
  header: "Technician",
  enableSorting: false,
  meta: { size: "20rem" },
  cell: ({ row }) => {
    const { employee_id: employeeId, technicianName } = row.original;

    if (!employeeId) {
      return (
        <Typography variant="bodyW1" textColor="secondary">
          Unknown technician
        </Typography>
      );
    }

    return (
      <Stack gap="none">
        {technicianName && (
          <Typography variant="bodyW1" className="truncate">
            {technicianName}
          </Typography>
        )}
        <Typography
          variant={technicianName ? "bodyW2" : "bodyW1"}
          textColor={technicianName ? "tertiary" : undefined}
        >
          #{employeeId}
        </Typography>
      </Stack>
    );
  },
};
